document.addEventListener("DOMContentLoaded", function () {
	var btn = document.getElementById("gform_submit_button_15");
	if (btn) {
		btn.addEventListener("click", function () {
			rdt("track", "Lead", {
				event_name: "pricing_button_click",
			});
		});
	}
});
